import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import { arrayMove } from 'react-sortable-hoc';
import ListSelectedItems from '../ListSelectedItems';
import ImageItem from '../../Image/ImageItem';

import {
	Modal,
	ModalWrapper,
	ModalContent,
	ModalHeader,
	ModalFooter,
	SelectableItems,
	SelectableItem,
	NoSelectedItems,
	SelectionCount
} from './styles';

import { BigBlueButton, GhostButton } from 'lib/styles';

class ListItems extends React.Component {
	constructor(props) {
		super(props);
		const value = props.value ? props.value.filter(id => props.items.find(item => item.id === id)) : []
		this.state = {
			activeIndex: -1,
			value: value,
			showSelectionModal: false,
			selectedItems: value
		};
	}

	onSortEnd({ oldIndex, newIndex }) {
		if (oldIndex === newIndex) {
			return;
		}

		const oldValue = this.state.value;
		this.setState({
			value: arrayMove(this.state.value, oldIndex, newIndex)
		}, () => {
			this.props.onChange(this.state.value, oldValue);
		});
	}

	onRemove() {
		const oldValue = this.state.value;
		const value = Array.from(oldValue);
		value.splice(this.state.activeIndex, 1);
		this.setState({
			value: value,
			activeIndex: -1
		}, () => {
			this.props.onChange(this.state.value, oldValue);
			this.props.onSelect(this.state.value[this.state.activeIndex] || null);
		});
	}

	activateValue(value) {
		this.setState({ activeIndex: value }, () => {
			this.props.onSelect(this.state.value[this.state.activeIndex] || null);
		});
	}

	toggleModal(toggle) {
		this.setState({
			showSelectionModal: toggle,
			selectedItems: toggle ? this.state.value : this.state.selectedItems
		});
	}

	selectViewItem(id) {
		const selectedItems = Array.from(this.state.selectedItems);
		const index = selectedItems.findIndex(val => val === id);
		if (index > -1) {
			selectedItems.splice(index, 1);
		}
		else {
			selectedItems.push(id);
		}

		this.setState({ selectedItems });
	}

	confirmSelections() {
		const oldValue = this.state.selectedItems;
		const activeItemChanged = this.state.activeIndex > -1 && this.state.selectedItems.includes(this.state.value[this.state.activeIndex]);
		this.setState({
			value: this.state.selectedItems,
			activeIndex: activeItemChanged ? -1 : this.state.activeIndex,
		}, () => {
			if (activeItemChanged) {
				this.props.onSelect(null);
			}
			this.props.onChange(this.state.value, oldValue);
		});

		this.toggleModal(false);
	}

	cancelSelections() {
		this.toggleModal(false);
	}

	render() {
		const t = this.props.t;
		const allItems = this.props.items;
		const selectedItems = this.state.value.map((id, i) => {
			const item = allItems.find(val => val.id === id);
			if (!item) {
				return false;
			}
			const data = {
				id: item.id,
				name: item.name,
				aspect: 0.5,
				fitImage: true,
				conversions: {
					min: item.icon
				},
				selected: i === this.state.activeIndex
			};
			data.element = <ImageItem {...data} />;
			return data;
		}).filter(val => !!val);


		const selectableItems = allItems.map(item => {
			return {
				id: item.id,
				name: item.name,
				aspect: 1,
				conversions: {
					min: item.icon
				},
			};
		}).sort((a, b) => {
			return a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1;
		});

		const labels = Object.assign({
			empty: 'controls/listitem/empty',
			select: 'controls/listitem/select',
			selected: 'controls/listitem/selected',
			title: 'controls/listitem/title',
			cancel: 'controls/listitem/cancel',
			confirm: 'controls/listitem/confirm',
			remove: 'controls/listitem/remove',
			noSelectableItems: 'controls/listitem/no items',
		}, this.props.labels || {});

		return (
			<React.Fragment>
				{this.state.value.length === 0 && (
					<NoSelectedItems>{t(labels.empty)}</NoSelectedItems>
				)}
				<ListSelectedItems
					activeIndex={this.state.activeIndex}
					activeIndexHandler={val => this.activateValue(val)}
					showButton={true}
					removeConfirmText={labels.remove}
					viewItemsText={labels.select}
					viewItemsToggleHandler={(val) => { if (val) { this.toggleModal(true) } }}
					saveHandler={() => this.onRemove()}
					onSortEndHandler={({ oldIndex, newIndex }) => this.onSortEnd({ oldIndex, newIndex })}
					items={selectedItems}
					t={t}
				/>
				<Modal open={this.state.showSelectionModal} onClick={() => this.cancelSelections()}>
					<ModalWrapper onClick={(e) => { e.preventDefault(); e.stopPropagation() }}>
						<ModalHeader>
							<span>{t(labels.title)}</span>
							<SelectionCount>{t(labels.selected).replace('%s%', this.state.selectedItems.length).replace('%t%', allItems.length)}</SelectionCount>
						</ModalHeader>
						<ModalContent>
							{selectableItems.length > 0 && (
								<SelectableItems>
									{selectableItems.map(item => (
										<SelectableItem key={item.id} item={item} selected={this.state.selectedItems.includes(item.id)} onClick={() => this.selectViewItem(item.id)}>
											<ImageItem {...item} />
										</SelectableItem>
									))}
								</SelectableItems>
							)}
							{selectableItems.length === 0 && (
								<NoSelectedItems>{t(labels.noSelectableItems)}</NoSelectedItems>
							)}
						</ModalContent>
						<ModalFooter>
							<GhostButton onClick={ () => this.cancelSelections() } style={{ marginRight: '1rem' }}>{t(labels.cancel)}</GhostButton>
							<BigBlueButton onClick={ () => this.confirmSelections() }>{t(labels.confirm)}</BigBlueButton>
						</ModalFooter>
					</ModalWrapper>
				</Modal>
			</React.Fragment>
		)
	}
}

ListItems.propTypes = {
	t: PropTypes.func,
	items: PropTypes.array,
	value: PropTypes.array,
	labels: PropTypes.shape({
		empty: PropTypes.string,
		select: PropTypes.string,
		title: PropTypes.string,
		cancel: PropTypes.string,
		confirm: PropTypes.string,
		remove: PropTypes.string,
		noSelectableItems: PropTypes.string,
	}),
	onChange: PropTypes.func,
}

export default translate('translations')(ListItems)
